import { Routes } from "@src/context/router/RouterContext";
import { useGlobalState } from "@src/hooks/useGlobalState";
import { useRouter } from "@src/hooks/useRouter";

export const useWishlistGoBack = (): { goBack: () => void } => {
    const router = useRouter();
    const { modelId, componentGroupId } = useGlobalState();

    return {
        goBack: () => {
            router.setRoute(modelId ? (componentGroupId ? Routes.SubGroupDetail : Routes.ComponentGroupOverview) : Routes.Landing);
        },
    };
};
